"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Sort runs in ascending order
 *
 * @param  {Array}  runs
 * @return {Array} sorted runs
 */

var sort = function sort(runs) {
  return runs.sort(function (a, b) {
    return a.start - b.start || a.end - b.end;
  });
};

var _default = sort;
exports["default"] = _default;